import { set } from "smarty/lib/cache";
import { initLazyLoad, includeJavascript, openSalesChannelModal, callPinterestAPI } from "@api/utils_2020";
import('./pbds-mainmenu.css')

const pbdsMainMenu = {
    init()
    {
        console.log("pbds-mainmenu: INIT");
        const urlParams = new URLSearchParams(window.location.search);
        const linkExterno = urlParams.get('linkExterno');
        const channelAccess = urlParams.get('channel');
        var firstLanguage = $('#firstLanguage').val();
        var timeoutsOpen = {};
        var timeoutsLeave = {};
        var currentIndex = 0;
        var availableCameras;
        var facingBackCameraIndex;
        var qrCodeAlreadyLoaded = false;
        var html5QrCodeScanner;

        // show modal to change line
        if(channelAccess == "exportacao" || channelAccess == "internacional" || channelAccess == "international") {
            if($('body').hasClass('productGroupColor') || $('body').hasClass('line') || $('body').hasClass('product')) {
                if(firstLanguage == 'pt_BR' || firstLanguage == 'pt_br' || firstLanguage == 'pt-br' || linkExterno == 1) {
                    if (changeChannelLang)
                    {
                         // recuperar cookie de linguagem para ir direto para o primeiro link
                        // 
                        var siteLangCookie = Util.getCookie('pbSiteLangLast');
                        if (typeof siteLangCookie != 'undefined' && siteLangCookie)
                        {
                            var siteLang = siteLangCookie.split('_')[0];
                        }
                        else
                        {
                            var siteLang = null;
                        }
                        lang = siteLangCookie;
                        //alert('Produto não está na exportação!');
                        UtilUi.loadTemplate("assets/components-pbds/pbds-modal--languages/pbds-modal--languages-unav-int.tpl", (dataOn, tpl) => {
                            var linkPt = window.location.href.split('?')[0] + '?channel=';
                            let html = tpl.fetch({ 
                                linkPt: linkPt,
                                pathPrefix: pathPrefix,
                                siteLang: siteLang
                             });
                            $("body").append(html);

                            $('#languages-modal-v3').showModal();
                        }, null, false, siteLangCookie);
                    }
                    else
                    {
                       
                        if (siteLang == 'en' || siteLang == 'es')
                        {
                            var linkToGo = $('#languages-modal-v2 .body ul li[data-lang="'+siteLang+'"] a').attr('href');
                            //alert(linkToGo);
                            window.location.href = linkToGo;
                        }
                        else
                        {
                            $('.jsLanguage').trigger('click');

                        }
                    }
                }
            }
        }


        if(typeof showAnotherChannelModal != 'undefined' && showAnotherChannelModal) {
            if($('body').hasClass('productGroupColor') || $('body').hasClass('line') || $('body').hasClass('product')) {
                    // recuperar cookie de linguagem para ir direto para o primeiro link
                UtilUi.loadTemplate("assets/components-pbds/pbds-modal--languages/pbds-modal--languages-unav.tpl", (dataOn, tpl) => {
                    var link = window.location.href.split('?')[0] + '?channel=reset';
                    let html = tpl.fetch({ 
                        link: link,
                        pathPrefix: pathPrefix,
                        siteLang: siteLang,
                        salesChannel: salesChannel
                        });
                    $("body").append(html);

                    $('#languages-modal-v5').showModal();
                }, null, false, siteLangCookie);
            }
        }
        
        $('.pbds-mainmenu .jsReset').on('click', function(e){
            e.preventDefault();

            Util.deleteCookie('channel');
            //Util.deleteCookie('channel', window.location.hostname, true);
            //Util.setCookie('channel','',-100,'/', window.location.hostname, true);
            window.location.href = '/';
            return false;
        });

        //#22865 - Ajustar - Fechar menu
        $(document).on('click', function (e) {
            //console.log(e.target);
            if (e.target.className == 'pbds-mainmenu type-channel ' || e.target.id == 'mainmenu') {
              // console.log('clicou fora')
              if ($('.pbds-mainmenu .menu > .wrapper > ul > li > button').siblings('.submenu').is(":visible")) {
                $('.pbds-mainmenu .menu > .wrapper > ul > li.selected > button').siblings('.submenu').toggle('blind', { direction: "up" }, 200);
                $('.pbds-mainmenu .menu > .wrapper > ul > li.selected > button').parent().toggleClass('selected');
              }
            }
            if (typeof e.target.className == 'string') {
              if ($(e.target).closest('.pbds-mainmenu').length > 0) {
                var selector = '';
          
                if (e.target.className) {
                  selector = '.' + e.target.className.replace(/\s+/g, '.');
                } else {
                  var parentWithClass = $(e.target).parents('[class]').first();
                  if (parentWithClass.length > 0) {
                    selector = '.' + parentWithClass[0].className.replace(/\s+/g, '.');
                  }
                }
                if (selector.slice(-1) == '.')
                {
                    selector = selector.substring(0,selector.length-1);
                }
          
                if (selector != ".") {
                  if ($(selector).parents('.user-menu').length == 0) {
                    if ($('.pbds-mainmenu .user-menu').siblings('.submenu').is(":visible")) {
                      $('.pbds-mainmenu .user-menu').siblings('.submenu').hide();
                      $('.pbds-mainmenu .user-menu').data('action', 'open');
                    }
                  }
          
                  if ($(selector).parents('.notification-menu').length == 0) {
                    if ($('.pbds-mainmenu .notification-menu').siblings('.notification-submenu').is(":visible")) {
                      $('.pbds-mainmenu .notification-menu').siblings('.notification-submenu').hide();
                      $('.pbds-mainmenu .notification-menu').data('action', 'open');
                    }
                  }
                }
              }
            }
          });
          

        // Toggle Submenus (Desktop)
        $('.pbds-mainmenu .menu > .wrapper > ul > li > button').on('click',function(){
            var fxOption;
            if($(window).width() < 1181) {
                fxOption = "right";
            } else {
                fxOption = "up";
            }
            console.log("MAIN CLICK: "+fxOption);
            if ($(this).siblings('.submenu').is(":visible")) {
                $(this).siblings('.submenu').toggle('blind',{direction: fxOption},200);
                $(this).parent().toggleClass('selected');
            } else {
                $('.pbds-mainmenu .menu > .wrapper > ul > li > .submenu').each(function(){
                    if ($(this).is(":visible")) {
                        $(this).toggle('blind',{direction: fxOption},200);
                        $(this).parent().toggleClass('selected');
                    }                    
                });
                $(this).siblings('.submenu').toggle('blind',{direction: fxOption},200);
                $(this).parent('li').toggleClass('selected');
                setTimeout(
                    function()
                    {
                        if (!$('.links.main li.selected .group.categories ul > li.selected .submenu').is(':visible'))
                        {
                            if (window.innerWidth > 1180 || isMobile) {
                                $('.links.main li.selected .group.categories ul > li > button.category').first().trigger('click');
                            }                       
                        }
                    }
                ,500);


            }        
            return false;
        });
        // Submenus de Categorias
        $('.pbds-mainmenu .group.categories .column-wrapper > ul > li > button.category').on('click',function(){
            var target = $(this).parent();
            if($(window).width() > 1180) {
                target.closest('ul').find('li.selected > .submenu.category').hide('fade',200);
                target.closest('ul').find('li.selected').removeClass('selected');
                target.addClass('selected');
                target.find('.submenu.category').show('fade',200);
                var menuHeight = target.find('.submenu.category .group.links').height();
                target.closest('.group.categories').parent().parent().css('min-height',menuHeight);
                target.closest('.column-wrapper').css('min-height',menuHeight);
                target.find('.group.links').css('min-height',menuHeight);
                target.find('.column.highlights').css('min-height',menuHeight);
            } else {
                target.closest('.group.categories').parent().parent().css('min-height',"0");
                target.find('.submenu.category').show('slide',{direction: "right"},200);
                target.find('.submenu.explicit').show('slide',{direction: "right"},200);
            }


            return false;
        });
        // Toggle Groups
        $('.pbds-mainmenu .menu .submenu .group button.title').on('click',function(){
            if($(window).width() < 1181) {
                $(this).siblings('.submenu').toggle('blind',{direction: "right"},200);
            }
            return false;
        });
        $('.pbds-mainmenu .jsMainmenu').on('click',function(){
            $('.pbds-mainmenu').find('.menu').toggle('slide',{direction: "right"},200);
            $('.pbds-mainmenu').toggleClass('stMobileOpened');
            return false;
        });
        $('.pbds-mainmenu .menu .header .jsClose').on('click',function(){
            $('.pbds-mainmenu').find('.menu').hide('slide',{direction: "right"},200);
            $('.pbds-mainmenu').find('.submenu').each(function(){
                $(this).hide('slide',{direction: "right"},200);
            });
            $('.pbds-mainmenu').find('li.selected').each(function(){
                $(this).removeClass('selected');
            });
            $('.pbds-mainmenu').removeClass('stMobileOpened');
            return false;
        });
        $('.pbds-mainmenu .submenu .header .jsBack').on('click',function(){
            console.log("CLICKED");
            $('.pbds-mainmenu').find('li.selected').each(function(){
                $(this).removeClass('selected');
            });
            $(this).closest('.submenu').hide('slide',{direction: "right"},200);
            return false;
        });
        // Carousels
        $('.pbds-mainmenu').find('.mainmenu-banners').find('button').on('click', function(){
            $(this).closest('.mainmenu-banners').find('.item-banner').each(function(){
                $(this).toggle("fade",200);
            });
        });    
        // User menu
        $('.pbds-mainmenu').find('.jsUserMenu').on('click', function(){
           var menu = $(this);
           var submenu = $('.pbds-mainmenu').find('.jsSubmenu');
           console.log(menu.data('action'));
           if (menu.data('action') == 'open') {
                submenu.show();
                menu.data('action', 'close');
            } else {
                submenu.hide();
                menu.data('action', 'open');
           }
        });

        $(".jsQRCode").on("click", function(evt) {
            console.log('...')
            evt.preventDefault();
          
            includeJavascript('/external_components/html5-qrcode/html5-qrcode.min.js', () => {
                const template = "assets/components/pb-mainmenu/pb-qrcode--modal.tpl";
                pbdsMainMenu.html5QrCodeScanner = new Html5Qrcode("preview");

                if (pbdsMainMenu.html5QrCodeScanner)
                {
                    pbdsMainMenu.html5QrCodeScanner.stop();
                }
                UtilUi.loadTemplate(template, (data, tpl) => {
                    const html = tpl.fetch();
    
                    $("body").append(html);
                    
                    $("#modal-qrcode").modal("show");
    
                    $("#modal-qrcode").on('hidden.bs.modal', function (e) {
                        pbdsMainMenu.qrCodeAlreadyLoaded = false;
                        pbdsMainMenu.html5QrCodeScanner.stop();
                        pbdsMainMenu.html5QrCodeScanner.clear();
                    });
    
                    Html5Qrcode.getCameras().then(cameras => {
                        const modelRegex = new RegExp("(([^()]+))", "g");
                        const userModel = window.navigator.userAgent.match(modelRegex)[1].split(";")[2];
    
                        // $("#qrCodemessage").hide();
                        let isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) || (navigator.userAgent.match(/Android/i))) && !window.MSStream
    
                        if (cameras.length === 1 && !isIOS) {
                            $("#switchCamera").fadeOut("fast");
                        }
                        
                        if (cameras.length > 0) {
                            availableCameras = cameras;
    
                            const facingBackCamera = availableCameras.filter(
                                (camera) => camera.label && camera.label.includes("back")
                            );
    
                            if (facingBackCamera.length) {
                                pbdsMainMenu.startCamera(facingBackCamera[0].id);
                                facingBackCameraIndex = availableCameras.indexOf(facingBackCamera[0]);
                                currentIndex = facingBackCameraIndex;
                            } else {
                                if (isIOS)
                                {                                    
                                    pbdsMainMenu.startCamera(availableCameras[0].id);
                                }
                                else
                                {
                                    let lastIndex = availableCameras.length - 1;
                                    pbdsMainMenu.startCamera(availableCameras[lastIndex].id);
                                }                                
                            }
    
                            if (currentIndex > availableCameras.length - 1) {
                                currentIndex = 0;
                            }
            
                            // pbdsMainMenu.startCamera(availableCameras[currentIndex].id);
                            currentIndex++;
                        } else {
                            console.error("No cameras found.");
                        }
    
                      }).catch(err => {
                        console.log('err', err)
                      });
                    
                    // remove css from lib
                    // $("#preview").children().first().hide();
                    // $("#preview").css('border', 'none');
                });
            });
        });

        $("body")
            .off("click", "#modal-qrcode #switchCamera")
            .on("click", "#modal-qrcode #switchCamera", function(evt) {
                evt.preventDefault();
                $("#qrCodemessage").fadeIn('fast');

                if (currentIndex > availableCameras.length - 1) {
                    currentIndex = 0;
                }

                pbdsMainMenu.startCamera(availableCameras[currentIndex].id);
                currentIndex++;
            });


        $('.pbds-mainmenu').find('.jsNotificationMenu').on('click', function(){
           var menu = $(this);
           var submenu = $('.pbds-mainmenu').find('.jsNotificationSubmenu');
           console.log(menu.data('action'));
           if (menu.data('action') == 'open') {
                submenu.show();
                menu.data('action', 'close');
            } else {
                submenu.hide();
                menu.data('action', 'open');
           }
        });   
        $('.pbds-mainmenu').find('.jsInternational').on("click",function(){
            var target = $(this).attr("data-target");
            console.log(target);
            $(target).showModal();
        }); 
        $('.pbds-mainmenu').find('.jsDialogClose').on("click",function(){
            $(this).closest('dialog').closeModal();
        });
        if (!isMobile)
        {
            var lastScrollTop = 0;
            window.document.addEventListener("scroll", function(){ 
                var st = window.pageYOffset || document.documentElement.scrollTop;
                // console.log(st);
                if (st > lastScrollTop){
                    if(st > 148){
                        //$('.pbds-mainmenu ul.links.main li.selected button').trigger('click');
                        $('.pbds-mainmenu ul.links.main li.selected div.submenu').hide();
                        $('.pbds-mainmenu ul.links.main li.selected').removeClass('selected');
                        $('body').attr('data-direction','down');
                        //$('header.pb-header').find('h1').hide();
                        //$('.pb-mainmenu ul.navbar-nav > li.login.selected').removeClass('selected');
                        
                    }
                } else {
                    $('body').attr('data-direction','up');
                    //$('header.pb-header').find('h1').fadeIn(3000);           
                }
                lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
                //$(".nav-item.active.notification").removeClass("selected"); // Hide notifications box
            }, false);
        }
    },

    startCamera: cameraId => {
        // console.log(cameraId)
        // return false
        if(pbdsMainMenu.qrCodeAlreadyLoaded) {
            pbdsMainMenu.html5QrCodeScanner.stop();
            pbdsMainMenu.html5QrCodeScanner = new Html5Qrcode("preview");
        } else {
            pbdsMainMenu.qrCodeAlreadyLoaded = true;
        }

        $("#qrCodemessage").hide();
        pbdsMainMenu.html5QrCodeScanner.start(
            cameraId,
            {
                fps: 30,
                qrbox: 200
            },
            qrCodeMessage => {
                const redirectURL = new URL(qrCodeMessage);

                if (redirectURL.host === "www.portobello.com.br" || redirectURL.host === "pb.local"  || redirectURL.host === "homologa.portobello.com.br") {
                    window.location.href = redirectURL;
                    pbdsMainMenu.html5QrCodeScanner.stop();
                    pbdsMainMenu.html5QrCodeScanner.clear();
                } else {
                    alert(_t("Produto não encontrado."));
                }
            },
            errorMessage => {
            })
        .catch(err => {
            alert(_t(`Não foi possivel iniciar o qr code! Erro: ${err}`) );
        });

    },
    
}

window.map = null;
window.initializeComponent.push({ component: "pbds-mainmenu", init: pbdsMainMenu.init });

export default() => {
    pbdsMainMenu.init();
}